module.exports = __webpack_public_path__ + "img/图1@2x.4b65d3e3.png";